import { MapViewerNode } from '@3ddv/dvm-internal';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ViewersService } from '../../../services/viewers.service';
import { Subscription, take } from 'rxjs';
import { SiteConfiguration } from '../../../configuration/configuration';

@Component({
  selector: 'app-selected-node',
  imports: [],
  templateUrl: './selected-node.component.html',
  styleUrl: './selected-node.component.css'
})
export class SelectedNodeComponent implements OnInit, OnDestroy {
  private readonly subscriptions: Subscription[] = [];

  // View step
  public currentMap!: 'topview' | 'seatmap';
  public is3dView!: boolean;

  // Node data
  private loadedNodeId: string = '';
  private loadedViewId: string = '';
  public nodeData: { section: string | null; row: string | null; seat: string | null; } = {
    section: null,
    row: null,
    seat: null
  };

  constructor(
    private readonly viewersService: ViewersService,
  ) { }

  ngOnInit(): void {
    // Update the current view step
    this.updateViewStep();
    // Update the current node data
    this.updateNodeData();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }
  
  private updateViewStep(): void {
    // Get 3D View status
    const is3d = this.viewersService.is3dView.subscribe((is3d: boolean) => {
      this.is3dView = is3d;
    });
    // Get Map View status
    const current = this.viewersService.currentMap.subscribe((current: 'topview' | 'seatmap') => {
      this.currentMap = current;
    });
    this.subscriptions.push(is3d, current);
  }

  private updateNodeData(): void {
    const loadSuccess: Subscription = this.viewersService.viewer.getObservable('load_success').subscribe((obj): void => {
      this.loadedNodeId = this.viewersService.viewer.getMapId()!;
      if (this.loadedNodeId !== SiteConfiguration.map.dvm.viewer.mapId) {
        this.parseNodeData(this.loadedNodeId);
      }
    });

    const load3dSuccess: Subscription = this.viewersService.viewer3d.getObservable('load_success').subscribe((obj): void => {
      this.loadedViewId = this.viewersService.viewer3d.getViewId()!;
      this.parseNodeData(this.loadedViewId);
    });

    this.subscriptions.push(loadSuccess, load3dSuccess);
  }

  private parseNodeData(nodeId: string): void {
    // console.log('Node ID:', nodeId);
    if (nodeId) {
      // Set the node label splitted in section, row and seat, if exists
      const splittedNode = nodeId.split('_')[1].split('-');
      this.nodeData = {
        section: splittedNode[0].split('(INT)')[0] || null,
        row: splittedNode[1] || null,
        seat: splittedNode[2] || null
      };
    }
  }

}
